<template lang="pug">
    .accordion-item
        header.card-header
            a.card-header-icon(
                @click="isCollapsed = !isCollapsed" 
                :class="{active: !isCollapsed}"
            )
                svg.plus.icon(v-if="isCollapsed" viewBox="0 0 512 512" fill="#888")
                    path(d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 368C269.3 368 280 357.3 280 344V280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H280V168C280 154.7 269.3 144 256 144C242.7 144 232 154.7 232 168V232H168C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H232V344C232 357.3 242.7 368 256 368z")

                svg.minus.icon(v-if="!isCollapsed" viewBox="0 0 512 512" fill="#FFF")
                    path(d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM168 232C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H168z")
                p.card-header-title {{panel.title}}
        .card-content(:class="{'hidden':isCollapsed }")
            div(v-if="!isCollapsed" v-html="panel.text")
</template>

<script>

import { get } from '@/helpers';


export default {
    name: 'Panel',
    mounted() {
        if (this.id) {
          const state = this.getCollapseState();
          if (state) {
            this.isCollapsed = state[this.id];
          }
        }
    },
    data() {
        return {
            delay: 150,
            mouseover: false,
            isCollapsed: true,
        }
    },
    props: {
        panel: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    computed: {
        hyperlink() {
            return get(this.panel, 'hyperlink') || {}
        },
        odd() {
          return this.index % 2 == 0;
        }
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        }
    },
}
</script>

<style lang="sass" scoped>
    @import "~@/assets/sass/variables"
    .accordion-item
        @apply mb-4
        .card-header-icon
            @apply w-full flex items-center text-base cursor-pointer
            background-color: #f4f4f4
            padding: 14px
            &.active
                @apply text-white
                background-color: $color-primary
            .icon
                @apply mr-4
                width: 15px
                height: 15px
        .card-content
            box-shadow: 0 1px 2px rgba(0,0,0,0.2)
            padding: 25px 14px
            ::v-deep
              a
                color: $color-primary
                &:hover
                    @apply underline
              strong
                @apply font-semibold
              ul
                @apply list-disc list-outside ml-4
                li
                  padding: 2px 0
              ol
                @apply list-decimal list-outside ml-4
                li
                  padding: 2px 0

</style>
